/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Pedagogical classification of this event kind. Used by clients to filter event-kind pickers (e.g. the oral-exam tab only shows kinds with kind=='oral_exam'). Decouples behavior from substring/prefix checks on the ``id``.
 */
export type EventKindKind = (typeof EventKindKind)[keyof typeof EventKindKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventKindKind = {
  oral_exam: 'oral_exam',
  proctored_exam: 'proctored_exam',
  generic: 'generic',
} as const;
